import { render } from "./CustomerVersion.vue?vue&type=template&id=06545570&scoped=true"
import script from "./CustomerVersion.vue?vue&type=script&lang=js"
export * from "./CustomerVersion.vue?vue&type=script&lang=js"

import "./CustomerVersion.vue?vue&type=style&index=0&id=06545570&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06545570"]])

export default __exports__